import Cluster from 'ol/source/Cluster'
import { getUid } from 'ol/util'
import { buffer, createEmpty, createOrUpdateFromCoordinate } from 'ol/extent'

class CityhubCluster extends Cluster
{
    constructor(options) {
        super(options);
        this.filters = options.filters;
        this.isValid = options.filterFunc || function() { return true; };

        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */
        this._map = options.map || null;

        // Whether the default behaviour of clicking on a cluster is to zoom into it.
        // this.zoomToBoundsOnClick = options.zoomToBoundsOnClick || true;
        // When you click a cluster at the bottom zoom level we spiderfy it so you can see all of its markers.
        // this.spiderfyOnMaxZoom = options.spiderfyOnMaxZoom || true;
        //If set, at this zoom level and below, markers will not be clustered.
        this.disableClusteringAtZoom = options.disableClusteringAtZoom || null;
    }

    setFilters(filters) {
        this.filters = filters;
    }

    /**
    * @protected
    */
    cluster() {
        if (this.resolution === undefined || !this.source) {
          return;
        }
        let mapView = this._map.getView();
        var currrentZoom = this._map ? Math.ceil(mapView.getZoom()) : null,
            maxZoom = this._map ? Math.ceil(mapView.getMaxZoom()) : null,
            minZoom = this._map ? Math.floor(mapView.getMinZoom()) : null;

        if (this.disableClusteringAtZoom !== null) {
            maxZoom = this.disableClusteringAtZoom - 1;
        }

        const extent = createEmpty();
        const mapDistance = this.disableClusteringAtZoom !== null && currrentZoom >= maxZoom ? 0 : this.distance * this.resolution;
        const features = this.source.getFeatures();

        /** @type {Object<string, true>} */
        const clustered = {};

        for (let i = 0, ii = features.length; i < ii; i++) {
            const feature = features[i];
            if (!(getUid(feature) in clustered)) {
                const geometry = this.geometryFunction(feature)
                if (geometry && this.isValid(feature, this.filters)) {
                    let neighbors = [];
                    if (mapDistance > 0){
                        const coordinates = geometry.getCoordinates();
                        createOrUpdateFromCoordinate(coordinates, extent)
                        buffer(extent, mapDistance, extent)

                        neighbors = this.source
                            .getFeaturesInExtent(extent)
                            .filter((neighbor) => {
                                if(!this.isValid(neighbor, this.filters)) {
                                    return false
                                }

                                const uid = getUid(neighbor);
                                if (uid in clustered) {
                                    return false;
                                }
                                clustered[uid] = true;
                                return true;
                            });
                    }else{
                        neighbors = [feature];
                    }

                    this.features.push(this.createCluster(neighbors, extent));
                }
            }
        }
    }

}

export default CityhubCluster;
